import { msg } from "@lingui/core/macro";
import type { MessageDescriptor } from "@lingui/core";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import SubscriptionsIcon from "@mui/icons-material/Subscriptions";
import type { SvgIconComponent } from "@mui/icons-material";

export interface IntegrationMeta {
  identifier: string;
  name: string;
  description: MessageDescriptor;
  /** MUI icon component, or null for image-based icons (e.g. Google Sheets) */
  Icon: SvgIconComponent | null;
  /** Path to image asset, used when Icon is null */
  iconSrc?: string;
  /** Whether this integration supports "Sync now" */
  syncable: boolean;
}

export const INTEGRATIONS: IntegrationMeta[] = [
  {
    identifier: "economic",
    name: "e-conomic",
    description: msg({
      context: "Integration description for e-conomic",
      message:
        "Accounting — customers, invoices, accounts, financial reporting",
    }),
    Icon: AccountBalanceIcon,
    syncable: true,
  },
  {
    identifier: "intempus",
    name: "Intempus",
    description: msg({
      context: "Integration description for Intempus",
      message: "Time registration — work hours, absence, overtime, expenses",
    }),
    Icon: AccessTimeIcon,
    syncable: true,
  },
  {
    identifier: "fenerum",
    name: "Fenerum",
    description: msg({
      context: "Integration description for Fenerum",
      message:
        "Subscription management — customers, subscriptions, invoices, MRR",
    }),
    Icon: SubscriptionsIcon,
    syncable: true,
  },
  {
    identifier: "google_sheets",
    name: "Google Sheets",
    description: msg({
      context: "Integration description for Google Sheets",
      message: "User-provided spreadsheets — query data from connected sheets",
    }),
    Icon: null,
    iconSrc: new URL("../../assets/google-sheets.png", import.meta.url).href,
    syncable: false,
  },
];

export const getIntegrationMeta = (
  identifier: string,
): IntegrationMeta | undefined =>
  INTEGRATIONS.find((i) => i.identifier === identifier);
